<div class="gw-flex gw-flex-col gw-gap-x-large">
  <p
    *ngIf="requiredUploadProgress().total > 0"
    class="gw-m-0 gw-text-sm gw-text-text-secondary"
  >
    {{
      'features.onboarding.steps.documentsForm.uploadProgress'
        | translate : requiredUploadProgress()
    }}
  </p>
  <app-file-upload
    *ngFor="let entry of documentEntries; let i = index"
    [label]="
      ('features.onboarding.steps.documentsForm.inputs.' +
        (entry.key | camelcase) | translate) + (entry.value ? ' *' : '')
    "
    [acceptedTypes]="['application/pdf', 'image/jpeg', 'image/png']"
    [completed]="isDocumentUploaded(entry.key)"
    (fileChange)="onFileChange($event, entry.key)"
  ></app-file-upload>
</div>
